import { calendarDate } from './reach';

type DatedCampaign = {
  status: string;
  deadline?: string | null;
  posts: Array<{ status: string }>;
};

/**
 * Where a dated campaign is (Prototype v7): Ended once it's retired or its end
 * date has passed; Running while it's approved and on; otherwise Upcoming
 * (being planned or waiting for approval). The list and the detail both read
 * it, so a campaign under ENDED never says "Planning" when opened.
 */
export type Phase = 'running' | 'upcoming' | 'ended';

export function phaseOf(c: DatedCampaign, now = new Date()): Phase {
  const dayStart = new Date(now);
  dayStart.setHours(0, 0, 0, 0);
  const end = calendarDate(c.deadline);
  if (c.status === 'completed' || (end && end.getTime() < dayStart.getTime())) return 'ended';
  return c.status === 'active' ? 'running' : 'upcoming';
}

const WENT_OUT = new Set(['approved', 'scheduled', 'published']);

/** None of its posts was ever approved. */
export const neverApproved = (c: DatedCampaign) => !c.posts.some((p) => WENT_OUT.has(p.status));

/**
 * How an ended campaign ended, for the list's tag and the detail's status:
 * "Not approved" / "Ended · never approved", or "Approved" / "Ended · approved".
 */
export function endedAs(c: DatedCampaign): { tag: string; status: string } {
  return neverApproved(c)
    ? { tag: 'Not approved', status: 'Ended · never approved' }
    : { tag: 'Approved', status: 'Ended · approved' };
}
